angular.module( 'acme.view.application.passes.create.modals.cancel', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.passes.create.modals.cancel.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var passesCreateModalsCancel = {
        name: 'application.passes.create.modals.cancel',
        url: '/passes/create/modals/cancel',
        views: {
          "main": {
            controller: 'PassesCreateModalsCancelController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/passes/create/modals/cancel/cancel.tpl.html'
          }
        },
        data: {
          pageTitle: '    ',
          /** Secure With Permissions **/
          permissions: []
        }
      };

    $stateProvider
      .state(passesCreateModalsCancel);
});
